<template lang="html">
  <v-data-table
    :headers="dynamicHeaders"
    :items="jobs"
    :search="search"
    :pagination.sync="pagination"
    sort-by="status"
    class="elevation-0">
    <template v-slot:items="props">
      <td>{{ props.item.name }}</td>
      <td v-if="!remodelerJobs">
        <v-btn flat color="primary" :to='"/admin/remodeler/" + props.item.remodeler_id'>
          {{ props.item.remodeler_name }}
        </v-btn></td>
      <td>
        <v-chip v-if="props.item.approval_status" :color="getColor(props.item.approval_status)" dark>{{ props.item.approval_status.toUpperCase() }}</v-chip>
      </td>
      <td>
        <v-btn flat icon color="primary" :to='"/admin/job/" + jobId(props.item)' v-if="props.item.approval_status != 'APPROVED'">
          <v-icon>fas fa-edit</v-icon>
        </v-btn>
      </td>
    </template>
  </v-data-table>
</template>

<script>
import Layout from '@/shared/Layout'

export default {
  props: ['remodelerJobs'],
  data () {
    return {
      search: '',
      pagination: {
        rowsPerPage: 10,
        sortBy: 'status'
      },
      jobs: this.remodelerJobs,
      headers: [
        {
          text: 'Name',
          value: 'name'
        },
        {
          text: 'Remodeler',
          value: 'remodeler_name'
        },
        {
          text: 'Status',
          value: 'approval_status'
        },
        {
          text: 'Actions'
        }
      ],
      remodelerHeaders: [
        {
          text: 'Name',
          value: 'name'
        },
        {
          text: 'Status',
          value: 'approval_status'
        },
        {
          text: 'Actions'
        }
      ]
    }
  },
  components: {
    Layout
  },
  computed: {
    dynamicHeaders () {
      if (this.remodelerJobs) {
        return this.remodelerHeaders
      } else {
        return this.headers
      }
    }
  },
  methods: {
    getColor (status) {
      if (status === 'APPROVED') return 'green'
      else if (status.toUpperCase() === 'APPROVAL_PENDING') return 'orange'
      else if (status.toUpperCase() === 'PENDING') return 'orange'
      else if (status.toUpperCase() === 'DRAFT') return 'grey'
      else if (status.toUpperCase() === 'REQUESTED_EDITS') return 'teal lighten-2'
      else return 'red'
    },
    jobId (item) {
      return item.id || item.job_id
    },
    getAllJobs () {
      this.$http({
        method: 'get',
        url: '/admin/jobs'
      }).then((response) => {
        this.jobs = response.data
      })
    },
    getRemodelerJobs () {
      this.$http({
        method: 'get',
        url: '/remodeler/' + this.remodelerId + '/jobs'
      }).then((response) => {
        this.jobs = response.data
      })
    }
  },
  mounted () {
    if (this.jobs == null) {
      this.getAllJobs()
    }
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/components/admin/Jobs/_table.vue